<app-public-reports-layout>
  <div class="display-flex full-height justify-content flex-align-center">
    <app-card style="max-width: 600px;">
      <form>
        <h3 class="mt-0 mb-10">{{ 'anonymousReport.password_required' | translate }}</h3>
        <p class="text-secondary mt-0">
          {{ 'anonymousReport.password_required_disclaimer' | translate }}
        </p>
        <app-separator></app-separator>
        <p class="text-secondary mb-0 display-flex flex-align-center">
          <app-input-password class="full-width"
                              [form]="form"
                              controlName="password"></app-input-password>
        </p>
        <div *ngIf="errors$ | async" class="error mb-10">
          <div *ngFor="let error of errors$ | async">{{ error | translate }}</div>
        </div>
        <p class="text-right mt-0 mb-0">
          <app-button type="submit"
                      buttonType="mat-flat-button"
                      icon="key"
                      [loader]="loading$ | async"
                      [disabled]="!form.valid || (loading$ | async)"
                      (onClick)="onSubmit()">{{ 'button.send' | translate }}</app-button>
        </p>
      </form>
    </app-card>
  </div>
</app-public-reports-layout>
